import React from 'react';
import { Link } from 'react-router-dom';
import { EXPLORE_PRIVACY_POLICY_URL } from '../config/legalUrls';

const wrap = {
  minHeight: '100dvh',
  background: 'var(--color-bg)',
  padding: '24px 18px 48px',
  maxWidth: 800,
  margin: '0 auto',
  boxSizing: 'border-box',
};

const back = {
  display: 'inline-block',
  marginBottom: 20,
  fontSize: 15,
  fontWeight: 600,
  color: 'var(--color-primary)',
  textDecoration: 'none',
};

const h1 = {
  fontSize: 'clamp(1.5rem, 4vw, 1.85rem)',
  fontWeight: 800,
  color: 'var(--color-text)',
  margin: '0 0 12px',
  letterSpacing: '-0.02em',
};

const h2 = {
  fontSize: 'clamp(1.05rem, 2.5vw, 1.2rem)',
  fontWeight: 700,
  color: 'var(--color-text)',
  margin: '28px 0 10px',
  lineHeight: 1.3,
};

const p = {
  fontSize: 16,
  lineHeight: 1.55,
  color: 'var(--color-text)',
  opacity: 0.82,
  margin: '0 0 16px',
};

const footerNote = {
  fontSize: 13,
  lineHeight: 1.45,
  color: 'var(--color-text)',
  opacity: 0.6,
  marginTop: 32,
  marginBottom: 0,
};

function AboutPage() {
  return (
    <main style={wrap}>
      <Link to="/" style={back}>
        ← Home
      </Link>
      <h1 style={h1}>About Explore</h1>

      <p style={p}>
        Explore provides short educational activities and topic-based learning content for children.
      </p>
      <p style={p}>
        Some content and explanations may be generated or assisted by AI. Content is reviewed before publication where
        applicable, but adults should still supervise use and help children evaluate information.
      </p>
      <p style={p}>
        Explore is intended for supervised educational use. It is not a social network, messaging service, childcare
        service, school replacement, medical resource, legal resource, or professional advice tool.
      </p>

      <h2 style={h2}>AI-assisted content</h2>
      <p style={p}>
        Some lessons, explanations, hints, and activity text may be created or supported using AI tools. AI-generated
        content can contain mistakes or omissions. Adults should review important information and guide children when
        needed.
      </p>

      <h2 style={h2}>Human review</h2>
      <p style={p}>
        Published learning activities may be reviewed by a person before being made available. This review is intended
        to improve clarity, age-appropriateness, and educational usefulness, but it does not guarantee that all content
        is complete, current, or error-free.
      </p>

      <h2 style={h2}>Supervised use</h2>
      <p style={p}>
        Explore is designed to support learning with adult involvement. Parents, guardians, or educators should decide
        whether the content and search results are appropriate for each child.
      </p>
      <p style={p}>
        Search features may use filtering tools, including Google Programmable Search with SafeSearch enabled where
        available. These tools can help reduce inappropriate results, but they do not guarantee that every result will be
        appropriate for every child. Adult supervision is still recommended.
      </p>

      <h2 style={h2}>No professional advice</h2>
      <p style={p}>
        Information in Explore is for general learning only and should not be used as a substitute for professional,
        medical, legal, safety, or educational advice.
      </p>

      <h2 style={h2}>Advertising and engagement</h2>
      <p style={{ ...p, marginBottom: 0 }}>
        Explore is not designed around streaks, social feeds, open messaging, or engagement pressure. Product features
        may change over time.
      </p>

      <p style={footerNote}>
        <a
          href={EXPLORE_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--color-primary)', fontWeight: 700 }}
        >
          Privacy Policy
        </a>
        {' · '}
        Offered by Kiddoware.
      </p>
    </main>
  );
}

export default AboutPage;
